// @flow

/**
 * Module dependencies.
 */

import { Container } from 'client/components/core/grid';
import { RetinaImage } from 'client/components/core/images';
import { colors, media, units } from 'client/styles';
import { translator } from 'core/utils';
import Information from 'client/components/about/information';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  logos: Array<string>,
  translate: Function
};

/**
 * Image styles.
 */

const imageStyles = `
  min-height: 48px;

  ${media.min.lg`
    width: auto;
    min-height: 60px;
  `}
`;

/**
 * `ImagesContainer` styled component.
 */

const ImagesContainer = styled.li`
  margin: 0 auto ${units(2)};
  position: relative;

  ${media.min.sm`
    display: inline-block;
    margin-bottom: 0;

    &:not(:last-child) {
      margin-right: ${units(7)};
    }
  `}
`;

/**
 * `ImagesList` styled component.
 */

const ImagesList = styled.ul`
  display: inline-block;
  list-style: none;
  padding: ${units(2)} 0;
  text-align: center;
  width: 100%;

  ${media.min.sm`
    text-align: left;
  `}

  ${media.min.lg`
    padding: ${units(6)} 0;
    white-space: nowrap;
  `}
`;

/**
 * Render note.
 */

const renderNote = (content: string, index: number): React$Element<*> => (
  <div key={index}>
    <Text.Small color={colors.shadesOfSand2.pampasLighter}>
      {content}
    </Text.Small>
  </div>
);

/**
 * `TeamExperience` component.
 */

function TeamExperience(props: Props): React$Element<*> {
  const { logos, translate } = props;
  const notes = [
    translate('about.shareholdersExperience.cardinal'),
    translate('about.shareholdersExperience.doubleCardinal')
  ];

  return (
    <Container>
      <Information
        lead={translate('about.shareholdersExperience.lead')}
        leadColor={colors.shadesOfSand2.pampasLighter}
        title={translate('about.shareholdersExperience.title')}
        titleColor={colors.shadesOfSand2.pampasLighter}
      >
        <ImagesList>
          {logos.map((filename: string) => (
            <ImagesContainer key={filename}>
              <RetinaImage
                baseWidth={'100px'}
                extension={'png'}
                filename={`logos/${filename}`}
                styles={imageStyles}
                title={filename}
              />
            </ImagesContainer>
          ))}
        </ImagesList>

        {notes.map(renderNote)}
      </Information>
    </Container>
  );
}

/**
 * Export `TeamExperience` component.
 */

export default translator()(TeamExperience);



// WEBPACK FOOTER //
// ../src/client/components/about/team-experience.js